import React from 'react';
import { Globe, DollarSign, Moon } from 'lucide-react';

const PreferencesSettings = () => {
  const preferences = [
    {
      title: 'Language',
      description: 'Choose your preferred language',
      icon: Globe,
      value: 'English',
      options: ['English', 'Spanish', 'French']
    },
    {
      title: 'Currency',
      description: 'Select your default currency',
      icon: DollarSign,
      value: 'TTD ($)',
      options: ['TTD ($)', 'USD ($)', 'EUR (€)']
    },
    {
      title: 'Theme',
      description: 'Choose light or dark mode',
      icon: Moon,
      value: 'Light',
      options: ['Light', 'Dark', 'System']
    }
  ];

  return (
    <div className="p-6">
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900">Preferences</h2>
        <p className="text-gray-600 mt-1">
          Customize your experience on Wright Tech Store
        </p>
      </div>

      <div className="space-y-6">
        {preferences.map((preference, index) => (
          <div key={index} className="border border-gray-200 rounded-lg p-6">
            <div className="flex items-start justify-between">
              <div className="flex items-start space-x-4">
                <div className="p-2 bg-primary-50 rounded-lg">
                  <preference.icon className="h-6 w-6 text-primary-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">{preference.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{preference.description}</p>
                </div>
              </div>
            </div>

            <div className="mt-6">
              <select
                className="w-full md:w-64 px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
                defaultValue={preference.value}
              >
                {preference.options.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 flex justify-end">
        <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700">
          Save Preferences
        </button>
      </div>
    </div>
  );
};

export default PreferencesSettings;